// import addLedgerScQy from '../components/ledgerScQy/addLedgerScQy.vue'
// import ledgerScQyList from '../components/ledgerScQy/ledgerScQyList.vue'

export default [
    {
        path: 'ledgerScQy/addLedgerScQy',
        component: resolve => require(['@/components/ledgerScQy/addLedgerScQy'],resolve),
        name: "AddLedgerScQy",
        meta:{
            id: '964',
            node: 'ledgerScQy',
            url: 'addLedgerScQy',
        }
    },
    {
        path: 'ledgerScQy/ledgerScQyList',
        component: resolve => require(['@/components/ledgerScQy/ledgerScQyList'],resolve),
        name: "LedgerScQyList",
        meta:{
            id: '963',
            node: 'ledgerScQy',
            url: 'ledgerScQyList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/ledgerScQy.js